'use strict';

exports.__esModule = true;
var withins = exports.withins = [{
	name: 'within 0.1 miles',
	value: 0.1
}, {
	name: 'within 8 miles',
	value: 8
}, {
	name: 'within 10 miles',
	value: 10
}, {
	name: 'within 15 miles',
	value: 15
}, {
	name: 'within 25 miles',
	value: 25
}, {
	name: 'within 50 miles',
	value: 50
}, {
	name: 'within 100 miles',
	value: 100
}, {
	name: 'within 500 miles',
	value: 500
}];


// WEBPACK FOOTER //
// ./components/search-page/lib/data/withins.js